import styled from 'styled-components';


export const QuoteHeaderWrapper = styled.div`
    .modal-header {
        align-items: start !important;
        border-bottom: unset;
    }
    .close-btn-ar button{
        margin: 0px;
        margin-top: -5px;
    }
    .title-section {

        h5 {
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 130%;
            letter-spacing: -0.03em;
            color: #1A1C1F;
        }
        hr {
            opacity: 0.1;
            border: 1px solid #D9DCE1;
            margin-top: .5rem;
            margin-bottom: .5rem;
        }
        p {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 160%;
            color: #455560;
        }
    }
`;

export const QuoteFooterWrapper = styled.div`
    .modal-footer {
        background: #F2F3F5;
        border-top: unset;
        padding: 24px 15px !important;
    }
    .continue-btn, .new-quotation-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 24px;
        gap: 8px;
        border-radius: 8px;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        color: #FFFFFF;
    }
    .continue-btn {
        background: #312E52;
    }
    .new-quotation-btn {
        background: #6B47F5;
    }
`;